import styled from "styled-components";
import { theme } from "../theme";

export const StyledError = styled.span`
	padding: 1rem;
	background-color: ${theme.color.red};
	color: ${theme.color.white};
`;
